// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__HwX1E","tab":"tabs_tab__GUN3Y","underline":"tabs_underline__1Mxe_","indicator":"tabs_indicator__19Qxp","chip":"tabs_chip__trf_a","active":"tabs_active__GHgDz"};